const cases = [
  {
    id: '1',
    category: '智能制造',
    topic: '数字化转型',
    title: '数字孪生技术在重型装备制造中的全生命周期应用',
    summary: '通过构建高精度数字孪生模型，实现从设计、制造到运维的全链条智能化监控，降低能耗并提升生产精度。',
    industry: '制造业 / 高端装备',
    publishDate: '2024-05-12',
    tags: ['数字孪生', '全生命周期', '标杆案例'],
    benchmark: true,
    coverImage: require('@/assets/img/code/img_3.jpg'),
    heroBadge: 'DIGITAL CURATOR',
    heroIntro: '汇聚学术前沿与行业标杆，通过深度解析企业管理、技术创新及社会责任领域的卓越实践，为学术研究与政策制定提供实证支持。',
    content: {
      backgroundTitle: '项目背景与挑战',
      background: [
        '在重型装备制造行业，传统的设计与制造流程长期面临“信息孤岛”与“验证滞后”的问题。大型机械设备的制造周期长、零部件成千上万，任何设计阶段的微小误差，都可能导致生产后期的巨额返工损失。',
        '某特大型重型机械集团在推进其全球化战略时，面临着提高生产效率、降低运维成本以及缩短产品交付周期的多重压力。传统的物理样机验证模式已无法满足现代敏捷制造的需求，建立一套覆盖研发、制造、运维全生命周期的数字化孪生体系成为了企业的核心战略。'
      ],
      solutionTitle: '核心技术与解决方案',
      solution: [
        {
          index: '01',
          title: '高保真三维建模',
          description: '利用物理引擎与高精度激光扫描，构建与实物 1:1 对应的数字化模型。'
        },
        {
          index: '02',
          title: '物联网数据融合',
          description: '通过工业网络将传感器数据实时反馈至虚拟模型，实现现场与数字空间的同步联动。'
        },
        {
          index: '03',
          title: 'AI 预测性维护',
          description: '基于历史运行数据与机器学习算法，对设备潜在故障进行提前预警与策略推荐。'
        }
      ],
      gallery: [
        require('@/assets/img/code/img_4.jpg'),
        require('@/assets/img/code/img_12.jpg'),
        require('@/assets/img/code/img_13.jpg')
      ],
      resultsTitle: '成果展示与社会价值',
      resultsSummary: '该项目在缩短交付周期、降低运维停机、提升能效利用方面形成可复制的实践路径，并为行业标准制定提供可验证样本。',
      videoDuration: '04:15',
      quote: '该项目的成功实施为传统制造业的数字化转型提供了可复制的“实践样板”，被列为省级智能制造示范项目。',
      quoteAuthor: '— 行业专家评审意见'
    }
  },
  {
    id: '2',
    category: '基础设施',
    topic: '智慧交通',
    title: '跨海大桥智能化施工管理体系实证研究',
    summary: '解析超大型基础设施建设中的多源数据融合管理，探讨 BIM+GIS 技术在复杂地理环境下的风险管控模型。',
    industry: '基建工程 / 交通运输',
    publishDate: '2024-04-20',
    tags: ['BIM', 'GIS', '风险管控'],
    benchmark: false,
    coverImage: require('@/assets/img/code/img_14.jpg'),
    heroBadge: 'INFRASTRUCTURE',
    heroIntro: '以复杂工程为样本，提炼数字化协同、质量安全与进度成本一体化管理的关键方法。',
    content: {
      backgroundTitle: '项目背景与挑战',
      background: [
        '跨海大桥施工过程涉及海况、气象、航运与多专业交叉作业，传统进度计划难以及时响应变化，且质量安全风险点密集。',
        '项目团队需要在保证安全与质量的前提下，提升多方协同效率与现场决策能力，减少返工与资源浪费。'
      ],
      solutionTitle: '核心技术与解决方案',
      solution: [
        {
          index: '01',
          title: 'BIM+GIS 一体化',
          description: '实现工程结构与地理环境同屏联动，支持关键工序可视化推演与冲突检查。'
        },
        {
          index: '02',
          title: '现场数据采集',
          description: '统一采集设备、材料、人员与环境数据，建立实时施工态势感知面板。'
        },
        {
          index: '03',
          title: '风险预警机制',
          description: '将风险清单与规则引擎结合，形成预警闭环与责任追踪链路。'
        }
      ],
      gallery: [
        require('@/assets/img/code/img_6.jpg'),
        require('@/assets/img/code/img_7.jpg'),
        require('@/assets/img/code/img_8.jpg')
      ],
      resultsTitle: '成果展示与社会价值',
      resultsSummary: '施工协同效率显著提升，关键风险实现可视化追踪，形成可复制的“智慧工地”治理方法。',
      videoDuration: '03:20',
      quote: '多源数据融合让决策更前置，工程治理从“事后纠偏”转向“事前预防”。',
      quoteAuthor: '— 项目管理委员会'
    }
  },
  {
    id: '3',
    category: '绿色能源',
    topic: '能源转型',
    title: '西北地区千万千瓦级风光电基地治理模式',
    summary: '研究新能源基地在电力外送与就地消纳方面的平衡策略，为国家能源结构转型提供行业标准样板。',
    industry: '能源行业 / 绿色转型',
    publishDate: '2024-03-28',
    tags: ['风光储', '电网协同', '双碳'],
    benchmark: true,
    coverImage: require('@/assets/img/code/img_15.jpg'),
    heroBadge: 'GREEN TRANSITION',
    heroIntro: '围绕“源网荷储”协同与治理机制创新，推动新能源高比例接入与低碳发展。',
    content: {
      backgroundTitle: '项目背景与挑战',
      background: [
        '新能源装机增长快，但并网消纳与调峰能力成为约束，弃风弃光与外送通道瓶颈并存。',
        '需要形成跨区域协同治理机制，统筹电源侧、电网侧与负荷侧资源。'
      ],
      solutionTitle: '核心技术与解决方案',
      solution: [
        {
          index: '01',
          title: '源网荷储协同',
          description: '通过储能配置与负荷引导机制，提升新能源消纳与稳定性。'
        },
        {
          index: '02',
          title: '电价与市场机制',
          description: '构建区域市场化交易方案，形成多方参与的收益分配与风险共担。'
        },
        {
          index: '03',
          title: '调度优化模型',
          description: '引入预测与优化算法，提升多时段调度的准确性与可解释性。'
        }
      ],
      gallery: [
        require('@/assets/img/code/img_11.jpg'),
        require('@/assets/img/code/img_9.jpg'),
        require('@/assets/img/code/img_10.jpg')
      ],
      resultsTitle: '成果展示与社会价值',
      resultsSummary: '形成可推广的新能源基地治理方法，为区域电力系统稳定运行与双碳目标达成提供支撑。',
      videoDuration: '05:05',
      quote: '治理机制创新与技术优化并行，是新能源高比例接入的关键路径。',
      quoteAuthor: '— 能源研究院'
    }
  },
  {
    id: '4',
    category: '数字治理',
    topic: '园区运营',
    title: '华东智慧科技园区运营调度枢纽',
    summary: '以园区运营为场景，整合能耗、安防、交通与服务体系，构建“一张图”调度与跨部门协同机制。',
    industry: '城市运营 / 园区管理',
    publishDate: '2024-02-10',
    tags: ['运营中台', '城市管理', '一张图'],
    benchmark: false,
    coverImage: require('@/assets/img/code/img_5.jpg'),
    heroBadge: 'SMART GOVERNANCE',
    heroIntro: '围绕园区治理的复杂协同问题，沉淀数字化运营体系与标准化治理流程。',
    content: {
      backgroundTitle: '项目背景与挑战',
      background: [
        '园区运营涉及多系统、多部门、跨场景，信息分散导致响应慢、协同成本高。',
        '需要统一的数据标准与调度机制，提升运行效率与服务体验。'
      ],
      solutionTitle: '核心技术与解决方案',
      solution: [
        {
          index: '01',
          title: '统一数据底座',
          description: '建立统一指标口径与事件模型，打通能耗、安防、物业与政务服务数据。'
        },
        {
          index: '02',
          title: '事件驱动调度',
          description: '通过事件中心实现告警、工单与联动策略，提升闭环处置效率。'
        },
        {
          index: '03',
          title: '运营驾驶舱',
          description: '以“一张图”呈现运行态势，支持多维分析与跨部门协同决策。'
        }
      ],
      gallery: [
        require('@/assets/img/code/img_1.jpg'),
        require('@/assets/img/code/img_2.jpg'),
        require('@/assets/img/code/img_0.jpg')
      ],
      resultsTitle: '成果展示与社会价值',
      resultsSummary: '园区应急响应更及时、运营成本更透明，形成可复用的数字治理标准与能力组件。',
      videoDuration: '02:50',
      quote: '以数据标准化为基础，才能把“协同”真正落到流程与责任链条上。',
      quoteAuthor: '— 园区运营负责人'
    }
  }
]

export function getCases () {
  return cases.slice()
}

export function getCaseCategories () {
  const categories = cases.map(item => item.category)
  return Array.from(new Set(categories))
}

export function getCaseById (id) {
  const normalized = String(id)
  return cases.find(item => item.id === normalized) || null
}

export function getHomeCaseCards () {
  return cases.slice(0, 4).map(item => ({
    id: item.id,
    category: item.category,
    title: item.title,
    image: item.coverImage
  }))
}

export function getRelatedCases (id, limit = 3) {
  const normalized = String(id)
  const pool = cases.filter(item => item.id !== normalized)
  return pool.slice(0, limit)
}




// WEBPACK FOOTER //
// ./src/utils/caseCenter.js